import { useBoundStore } from 'app/store';

import { UserFormProvider } from '../model';

import { EditFormContainer } from './EditFormContainer';
import { ReadonlyFormWrap } from './ReadonlyFormWrap';

export const UserFormPage = () => {
  const patientInfoData = useBoundStore((state) => state.hsptlzForm.patientInfoData);
  const isEditable = patientInfoData.usrTelNoUdpYn === 'Y' && patientInfoData.usrAddrUdpYn === 'Y';

  return (
    <UserFormProvider>
      {isEditable ? <EditFormContainer patientInfoData={patientInfoData} /> : <ReadonlyFormWrap />}
    </UserFormProvider>
  );
};

export default UserFormPage;
